"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var LinkedIn = function LinkedIn(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 15",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.58 2.74a2.503 2.503 0 0 0-1.742-1.738C16.278.585 10.01.585 10.01.585s-6.257-.01-7.833.417A2.503 2.503 0 0 0 .44 2.74a25.984 25.984 0 0 0-.435 4.84 26.335 26.335 0 0 0 .435 4.818 2.513 2.513 0 0 0 1.738 1.742c1.56.417 7.833.417 7.833.417s6.253 0 7.828-.417a2.515 2.515 0 0 0 1.742-1.742c.287-1.588.427-3.203.417-4.817a26.18 26.18 0 0 0-.417-4.841ZM8.007 10.572V4.576l5.219 3.005-5.219 2.991Z",
    fill: color
  }));
};
var _default = exports["default"] = LinkedIn;